<template>
  <div class="calendar font-sf-pro">
    <div class="text-center font-sf-pro font-medium capitalize text-base">
      <h3>
        {{
          dayjs()
            .month(month - 1)
            .locale('ru')
            .format('MMMM')
        }}
      </h3>
    </div>
    <div class="grid grid-cols-7 px-4 pb-8 pt-3 gap-1">
      <div
        v-for="(day, index) in days"
        :key="index"
        class="calendar-day cursor-pointer mx-auto font-sf-pro"
        :disabled="isDisable(day)"
        :class="{
          'border border-primary-100 rounded-2xl': today(day),
          sun: sunday(day),
          'p-1 !text-white rounded-2xl bg-primary-100': isSame(day.$d),
          '!text-gray-200 !cursor-not-allowed': isDisable(day)
        }"
        style="-webkit-tap-highlight-color: rgba(0, 0, 0, 0)"
        :style="{ gridColumn: setGridColumn(index) }"
        @click="selectDate(day.$d)"
      >
        {{ day.format('D') }}
      </div>
    </div>
  </div>
</template>

<script setup>
import dayjs from 'dayjs'
import 'dayjs/locale/ru'

const { formatDate } = useDate()

const props = defineProps({
  year: { type: Number, default: dayjs().year() },
  month: { type: Number, default: dayjs().month() + 1 },
  activeDate: { type: String, default: '' }
})

const selectedDate = ref(null)

const days = ref([])

const emit = defineEmits(['select-date'])

function selectDate (value) {
  if (isDisable(value)) { return }
  selectedDate.value = formatDate(value, 'YYYY-MM-DD')
  emit('select-date', selectedDate.value)
}

onMounted(() => {
  const monthDate = dayjs(`${props.year}-${props.month}-1`).startOf('month')
  days.value = [...Array(monthDate.daysInMonth())].map((_, i) => {
    return monthDate.clone().add(i, 'day')
  })
})

function column (index) {
  if (index === 0) {
    return days.value[0].day()
  }
}

function columnSunday (index) {
  if (index === 0) {
    return 7
  }
}

function setGridColumn (index) {
  return days.value[0].startOf('month').format('ddd') !== 'Sun' ? column(index) : columnSunday(index)
}

function isSame (day) {
  const first = formatDate(day, 'YYYY-MM-DD')

  return first === props.activeDate
}

function isDisable (day) {
  let today = new Date()
  today = formatDate(today, 'YYYY-MM-DD')
  return dayjs(today).isAfter(day)
}

function today (day) {
  return dayjs().isSame(day, 'day')
}

function sunday (day) {
  return dayjs(day).format('ddd') === 'Sun' || dayjs(day).format('ddd') === 'Sat'
}
</script>

<style scoped>
.calendar {
  min-height: 100%;
  background-color: #fff;
}
.calendar-title {
  padding: 1em;
  background-color: #eee;
  background-image: linear-gradient(to bottom, #edeeef, #e5e6e9);
  text-align: center;
  border-radius: 0.35em 0.35em 0 0;
}

.calendar-wrapper {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  padding: 1em;
}

.calendar-day {
  width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.3125em;
}

.sun {
  color: #d00;
}
</style>
